/**
 * Check if the device is an Android device
 * @returns {boolean} True if the device is an Android device, false otherwise
 */
export default function isAndroidDevice(): boolean {
    if (typeof window === 'undefined') return false;

    const userAgent = window.navigator.userAgent.toLowerCase();
  
    return userAgent.includes('android');
}